import { Component, HostBinding } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'gl-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    standalone: false
})
export class ErrorPageComponent {
  @HostBinding('class.server-error') public isServerError;
  constructor(public router: Router, public route: ActivatedRoute) {
    this.isServerError = !!this.route.snapshot.queryParams.code;
  }

  public goToHomepage() {
    this.router.navigate(['']);
  }
}
